import {
    Box,
    Tooltip,
    Typography,
} from '@mui/material';
import { Lock } from '@mui/icons-material';
import DateFormat from '../../../utils/DateFormat';
import { useTranslation } from 'react-i18next';

let variant = 'body2'

function TimeKeepingCalendarEvent({ event }) {
    const {t} = useTranslation();

    return (
        <>
            {event.type === 'WORK_ENTRY' && event.submitted && event.isLast &&
                <Box sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'flex-end',
                    color: 'black',
                    overflow: 'visible'
                }}>
                    <Box>
                        <Tooltip
                            title={''}
                            sx={{ zIndex: 5 }}
                        >
                            <Lock />
                        </Tooltip>
                    </Box>
                </Box>
            }
            {event.allDay &&
                <Box sx={{ height: '100%' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', fontWeight: 'normal' }}>
                            <Typography variant={variant}>{t('soll', { ns: 'timeKeepingPage', defaultValue: 'Soll' })}:</Typography>
                            <Typography variant={variant}>{DateFormat.formatDuration(event.contractWorkLoad)}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant={variant}>{t('ist', { ns: 'timeKeepingPage', defaultValue: 'Ist' })}:</Typography>
                            <Typography variant={variant}>{DateFormat.formatDuration(event.actual)}</Typography>
                        </Box>
                        <hr />
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant={variant} >{t('differenz', { ns: 'timeKeepingPage', defaultValue: 'Differenz' })}:</Typography>
                            <Typography variant={variant} style={{  color: event.difference < 0 ? 'red' : event.difference === 0 ? '' : 'green', fontWeight: 'bold' }}>{event.difference > 0 ? '+' : ''}{DateFormat.formatDuration(event.difference)}</Typography>
                        </Box>
                </Box>
            }
        </>
    );
};

export default TimeKeepingCalendarEvent;
